import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { FlagsmithFlags } from '../../shared/models/flagsmith-flags.enum';
import type { FlagsmithFeatureFlagState } from '../reducers/flagsmith-feature-flag.reducer';
import { flagsmithFeatureFlagAdapter, flagsmithFeatureFlagStateKey } from '../reducers/flagsmith-feature-flag.reducer';

export const selectFlagsmithFeatureFlagState =
  createFeatureSelector<FlagsmithFeatureFlagState>(flagsmithFeatureFlagStateKey);

export const selectFlagsmithFeatureFlagsLoaded = createSelector(
  selectFlagsmithFeatureFlagState,
  (state: FlagsmithFeatureFlagState) => state.loaded
);

const { selectAll, selectEntities } = flagsmithFeatureFlagAdapter.getSelectors();
export const selectAllFlagsmithFeatureFlags = createSelector(selectFlagsmithFeatureFlagState, selectAll);
export const selectFlagsmithFeatureFlagEntities = createSelector(selectFlagsmithFeatureFlagState, selectEntities);

export const selectFlagsmithFeatureFlag = (featureFlagKey: FlagsmithFlags) =>
  createSelector(selectFlagsmithFeatureFlagEntities, (featureFlagEntities) => {
    return featureFlagEntities[featureFlagKey];
  });

export const selectFlagsmithFeatureFlagIsEnabled = (featureFlagKey: FlagsmithFlags) =>
  createSelector(selectFlagsmithFeatureFlag(featureFlagKey), (featureFlagEntity) => {
    return Boolean(featureFlagEntity?.enabled);
  });
